export default __webpack_public_path__ + "static/media/ic_info_white.123d8b31.svg";